import { Component } from '@angular/core';
import { CruiseService } from '../../services/cruise.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent {
  title = 'Cruize'; public loginType = '';

  constructor(private cruiserService: CruiseService) {
    this.loginType = this.cruiserService.getloginType();
  }
}
